import React from 'react';

import { Icon } from 'semantic-ui-react';

import { SortableContainer, SortableHandle } from 'react-sortable-hoc';

import AddAccordionPaneButton from './AddAccordionPaneButton';
import SortableAccordionItem from './SortableAccordionItem';

const DragHandle = SortableHandle(() => <Icon name="bars" className="drag-handle" />);

const SortableAccordionList = SortableContainer(
  ({
    panels,
    onItemCreate,
    onTitleChange,
    onContentChange,
    onRemove,
    onActiveChange,
    onSortStart,
  }) => (
    <div className="sortable-list">
      {panels.map((panel, index) => (
        <SortableAccordionItem
          id={panel.id}
          key={panel.id}
          itemData={panel}
          index={index}
          itemIndex={index}
          onTitleChange={onTitleChange}
          onContentChange={onContentChange}
          onRemove={onRemove}
          onActiveChange={onActiveChange}
          showDelete={panels.length > 1}
          DragHandle={DragHandle}
          onSortStart={onSortStart}
        />
      ))}
      <AddAccordionPaneButton onClick={() => onItemCreate(panels.length + 1)} />
    </div>
  ),
);

export default SortableAccordionList;
